import { Brain, Calendar, Droplet, ThermometerSun, AlertTriangle } from "lucide-react";

const DemoPredictions = () => {
  const predictions = [
    {
      days: 2,
      type: "watering" as const,
      message: "Vos tomates cerises auront besoin d'eau",
      priority: "high" as const,
    },
    {
      days: 3,
      type: "temperature" as const,
      message: "Températures fraîches - surveillez vos plants",
      priority: "medium" as const,
    },
  ];

  const getIcon = (type: "watering" | "temperature") => {
    switch (type) {
      case "watering":
        return <Droplet className="w-4 h-4 text-blue-500" />;
      case "temperature":
        return <ThermometerSun className="w-4 h-4 text-orange-500" />;
    }
  };

  const getPriorityColor = (priority: "high" | "medium" | "low") => {
    switch (priority) {
      case "high":
        return "border-l-red-500 bg-red-50";
      case "medium":
        return "border-l-yellow-500 bg-yellow-50";
      default:
        return "border-l-green-500 bg-green-50";
    }
  };

  return (
    <div className="bg-gradient-to-br from-purple-50 to-indigo-50 rounded-xl p-3 border border-purple-100">
      <div className="flex items-center gap-2 mb-2">
        <Brain className="w-4 h-4 text-purple-500" />
        <span className="text-xs font-semibold text-slate-700">Conseil de l'Expert !</span>
        <span className="text-[9px] text-slate-400 ml-auto">Basé sur vos données</span>
      </div>

      <div className="space-y-2">
        {predictions.map((prediction, index) => (
          <div key={index} className={`p-2 rounded-lg border-l-4 ${getPriorityColor(prediction.priority)}`}>
            <div className="flex items-start gap-2">
              {getIcon(prediction.type)}
              <div className="flex-1 min-w-0">
                <p className="text-[10px] font-medium text-slate-700 leading-tight">{prediction.message}</p>
                <div className="flex items-center gap-1 mt-0.5 text-[9px] text-slate-500">
                  <Calendar className="w-2.5 h-2.5" />
                  {prediction.days === 1 ? "Demain" : `Dans ${prediction.days} jours`}
                </div>
              </div>
              {prediction.priority === "high" && (
                <AlertTriangle className="w-3 h-3 text-red-500 animate-pulse shrink-0" />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DemoPredictions;
